import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from '../../store/actions';
import Commission from '../Commission/Commission';

class SectionFive extends Component {

  
  render() {
    return (
        <div className="section-five">
          <div className="section-five-content">
            <Commission/>
          </div>
        </div>
    );
  }
};

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openPopUp: (type) => dispatch(actions.openPopUp(type))
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SectionFive)
);